"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TOKEN = 'token';
var USER = 'user';
var AuthenticationService = /** @class */ (function () {
    function AuthenticationService() {
    }
    AuthenticationService.prototype.getCredentials = function () {
        return localStorage.getItem(TOKEN);
    };
    AuthenticationService.prototype.setUserOnLocalStorage = function (user) {
        localStorage.setItem(USER, JSON.stringify(user));
        this.setBase64ParsedAsToken();
    };
    AuthenticationService.prototype.getUserFromLocalStorage = function () {
        var u = localStorage.getItem(USER);
        var user = JSON.parse(u);
        return user;
    };
    AuthenticationService.prototype.setBase64ParsedAsToken = function () {
        var user = this.getUserFromLocalStorage();
        if (user) {
            var token = 'Basic ' + btoa(user.username + ':' + user.password);
            localStorage.setItem(TOKEN, token);
        }
    };
    AuthenticationService.prototype.removeUser = function () {
        localStorage.clear();
    };
    AuthenticationService.ctorParameters = function () { return []; };
    return AuthenticationService;
}());
exports.AuthenticationService = AuthenticationService;
//# sourceMappingURL=authentication.service.js.map


// WEBPACK FOOTER //
// authentication.service.js